import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "clearAllButton",
    "categoryFilter",
    "categoryLink",
    "settingsList",
    "emptyState",
  ];

  static values = {
    refreshUrl: String,
  };

  connect() {
    console.log("Global settings controller connected");
  }

  filterByCategory(event) {
    event.preventDefault();

    // Update active category visually
    this.categoryLinkTargets.forEach((link) => {
      link.classList.remove(
        "bg-primary-100",
        "text-primary-800",
        "dark:bg-primary-900",
        "dark:text-primary-200",
      );
      link.classList.add(
        "bg-gray-100",
        "text-gray-700",
        "dark:bg-gray-800",
        "dark:text-gray-300",
      );
    });

    event.target.classList.remove(
      "bg-gray-100",
      "text-gray-700",
      "dark:bg-gray-800",
      "dark:text-gray-300",
    );
    event.target.classList.add(
      "bg-primary-100",
      "text-primary-800",
      "dark:bg-primary-900",
      "dark:text-primary-200",
    );

    // Let Turbo handle the navigation
    const url = event.target.href;
    Turbo.visit(url, { frame: "global_settings_content" });
  }

  clearAllCache(event) {
    if (!confirm("Are you sure you want to clear all caches?")) {
      event.preventDefault();
      return;
    }

    // Show loading state
    const button = event.target;
    const originalText = button.textContent;
    button.textContent = "Clearing...";
    button.disabled = true;

    // Reset button after a delay (Turbo will handle the actual response)
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
  }

  clearCategoryCache(event) {
    const category = event.target.dataset.category;
    if (!confirm(`Clear cache for ${category} category?`)) {
      event.preventDefault();
      return;
    }

    // Show loading state
    const button = event.target;
    const originalText = button.textContent;
    button.textContent = "Clearing...";
    button.disabled = true;

    // Reset button after a delay
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1500);
  }

  // Handle successful operations with toast notifications
  showSuccessToast(message) {
    // You can integrate with your existing toast system here
    this.showToast(message, "success");
  }

  showErrorToast(message) {
    this.showToast(message, "error");
  }

  showToast(message, type = "info") {
    window.showToast(message, type);
  }

  // Handle Turbo events
  refreshContent() {
    Turbo.visit(this.refreshUrlValue, { frame: "global_settings_content" });
  }
}
